import { render, staticRenderFns } from "./ReportListSidebar.vue?vue&type=template&id=95d86b36&scoped=true&"
import script from "./ReportListSidebar.vue?vue&type=script&lang=js&"
export * from "./ReportListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ReportListSidebar.vue?vue&type=style&index=0&id=95d86b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d86b36",
  null
  
)

export default component.exports